'use strict';

var Sugar = require('sugar-core');

require('./build/buildDateUnitMethodsCall');

module.exports = Sugar.Date.weeksAgo;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/date/weeksAgo.js
// module id = 609
// module chunks = 0